import styled from 'styled-components';

export const AudioModalMessageContainer = styled.div`
  text-align: center;
  margin: ${({ theme }) => theme.spacing.l} 0;
`;
